module.exports = __webpack_public_path__ + "static/media/grinning-squinting-face-svgrepo-com.a5258f61.svg";